<template>
  <Modal v-model="showModal" :scrollable="true" :mask-closable="false" :width="width" @on-cancel="closeModal">
    <p slot="header">
      <Icon type="md-create" />
      <span class="header-label">{{ title }}</span>
    </p>
    <div style="position: relative;">
      <Spin v-if="loadingStatus" fix />
      <Form ref="form" :label-width="90" :model="formFields" :rules="ruleValidate">
        <FormItem label="文档编号:" prop="code">
          <Input v-model="formFields.code" placeholder="请输入协议编号..." size="small" />
        </FormItem>
        <FormItem label="文档名称:" prop="name">
          <Input v-model="formFields.name" placeholder="请输入协议名称..." size="small" />
        </FormItem>
        <!-- <FormItem label="协议版本:" prop="version">
          <Input v-model="formFields.version" placeholder="请输入协议版本..." size="small" />
        </FormItem> -->
        <FormItem label="文档描述:" prop="description">
          <Input v-model="formFields.description" placeholder="请输入协议描述..." size="small" />
        </FormItem>
        <!-- <FormItem label="需要签合同:" prop="status">
          <RadioGroup v-model="formFields.status">
            <Radio :label="1" :true-value="1">
              是
            </Radio>
            <Radio :label="0" :true-value="0">
              否
            </Radio>
          </RadioGroup>
        </FormItem> -->
        <FormItem label="是否启用:" prop="status">
          <RadioGroup v-model="formFields.status">
            <Radio :label="1" :true-value="1">
              启用
            </Radio>
            <Radio :label="0" :true-value="0">
              停用
            </Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="文档内容:">
          <RichTextEditor :value="content" @change="onContentChange" />
        </FormItem>
        <input v-model="formFields.id" type="hidden" name="id"></input>
      </Form>
    </div>
    <div slot="footer">
      <Button
        type="primary"
        :disabled="loadingStatus"
        size="small"
        icon="ios-checkmark-circle-outline"
        :loading="submit"
        @click="saveOrUpdate"
      >
        保存
      </Button>
    </div>
  </Modal>
</template>

<script>
import { htmlEncode, htmlDecode } from '@/utils/util'
import RichTextEditor from '@/components/rich-editor'
import request from '@/utils/request'
export default {
  name: 'UserContractDetails',
  components: { RichTextEditor },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 500
    },
    action: {
      type: String,
      default: ''
    },
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loadingStatus: false,
      modal: true,
      submit: false,
      content: '',
      formFields: {
        name: '',
        code: '',
        // version: 1,
        status: 1,
        content: '',
        description: '',
        id: this.id
      },
      ruleValidate: {
        name: [
          { required: true, message: '文档名称不能为空!', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '文档编号不能为空!', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    title() {
      if (this.caption) {
        return this.caption
      } else {
        return this.id ? '编辑协议' : '添加新协议'
      }
    },
    showModal: {
      get() { return this.visible },
      set(value) { }
    }
  },
  watch: {
    showModal(val) {
      this.resetForm()
      this.loadingStatus = false
      if (this.action && this.id) {
        this.loadingStatus = true
        request({
          url: this.action + '/' + this.id,
          method: 'get'
        }).then(res => {
          this.loadingStatus = false
          this.formFields = res.data
          this.content = htmlDecode(this.formFields.content)
        }).catch(() => {
          // this.$Notice.error({
          //   title: '服务器数据请求失败',
          //   desc: '请求地址: ' + this.action + ', 错误信息: ' + error
          // })
          this.loadingStatus = false
        })
      }
    }
  },
  methods: {
    onContentChange(content) {
      this.formFields.content = htmlEncode(content)
    },
    resetForm: function() {
      this.$refs.form.resetFields()
      this.formFields.id = 0
    },
    saveOrUpdate: function() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.action) {
            this.$refs.form.validate((valid) => {
              if (valid) {
                this.submit = true
                const isNew = this.formFields.id === 0
                request({
                  url: this.action + (isNew ? '' : ('/' + this.id)),
                  method: isNew ? 'POST' : 'PUT',
                  data: this.formFields
                }).then(res => {
                  this.loadingStatus = false
                  this.formFields = res.data
                  this.$Notice.success({
                    title: '文档 `' + this.formFields.name + '` 保存成功!'
                  })
                  this.submit = false
                  this.closeModal(true)
                }).catch(() => {
                  // this.$Notice.error({
                  //   title: '服务器数据请求失败',
                  //   desc: '请求地址: ' + this.action + ', 错误信息: ' + error
                  // })
                  this.loadingStatus = false
                  this.submit = false
                })
              }
            })
          }
        }
      })
    },
    closeModal: function(changed = false) {
      this.$emit('on-close', changed)
    }
  }
}
</script>
